import { urlify } from '../utils/string';

export default (state = {}, action = {}) => {
	if (action.type === 'PRODUCT_CACHE') {
		// Create styleup tables.
		// Sorting done dynamically.

		// Name - Search
		const cache = action.productCache.content;
		const { languages, categories, categoryTitles, categoryTitlesLocalized } = action.productCache; // Languages WP setting not Centra.
		const filterArrays = {
			categories, // Object mapping category paths to arrays of product keys.
			productGroup: {},
			colors: {}, // Object mapping color names to arrays of product keys.
			styles: {}, // Object mapping color names to arrays of product keys.
			rise: {},
			sizes: {
				jeans: {},
				other: {},
			}, // Object mapping sizes to arrays of product keys.
			washes: {}, // Object mapping color names to arrays of product keys.
			productsOnSale: [], // Array of product keys
			newProducts: [], // Array of product keys
		};
		const filterDescriptions = {
			categories: categoryTitles,
			colors: {},
			styles: {},
			rise: {},
			washes: {},
			sizes: {},
		};
		const languageKeys = Object.keys(languages);
		const searchTerms = languageKeys.reduce((acc, language) => ({ ...acc, [language]: {} }), {});

		const localized = languageKeys.slice(1).reduce((acc, language) => ({
			...acc,
			[language.value]: {
				categories: categoryTitlesLocalized ? categoryTitlesLocalized[language.value] : {},
				filterCategories: {},
				colors: {},
				styles: {},
				rise: {},
				washes: {},
			},
		}), {}); // Merged localized version of above.

		/*
			Localized versions shouldn't create new arrays.
			Their arrays exist but at their non-translated key.
			How to map their keys with their localized versions.
		*/

		Object.keys(cache).forEach((cacheKey) => {
			const item = cache[cacheKey];
			if (item.productHidden || Object.keys(item.categories).length === 0) return;
			let categoryType = 'other';

			const productNameUrlified = urlify(item.name);
			if (!filterArrays.productGroup[productNameUrlified]) filterArrays.productGroup[productNameUrlified] = [];
			filterArrays.productGroup[productNameUrlified][filterArrays.productGroup[productNameUrlified].length] = cacheKey;

			// Category lookup
			Object.keys(item.categories).forEach((category) => {
				const categoryItem = item.categories[category];
				if (categoryItem.uri.indexOf('jeans') !== -1) categoryType = 'jeans';
			});

			// Colors lookup
			if (item.variant_color_swatch) {
				Object.keys(item.variant_color_swatch).forEach((colorKey) => {
					const colorItem = item.variant_color_swatch[colorKey];
					const colorItemUrlified = urlify(colorItem.text);

					if (!filterArrays.colors[colorItemUrlified]) {
						filterArrays.colors[colorItemUrlified] = [];
						filterDescriptions.colors[colorItemUrlified] = colorItem;
					}
					filterArrays.colors[colorItemUrlified][filterArrays.colors[colorItemUrlified].length] = cacheKey;
				});
			}

			// washes lookup
			if (item.variant_wash_swatch) {
				const washItemUrlified = urlify(item.variant_wash_swatch.text);
				if (!filterArrays.washes[washItemUrlified]) {
					filterArrays.washes[washItemUrlified] = [];
					filterDescriptions.washes[washItemUrlified] = item.variant_wash_swatch;
				}
				filterArrays.washes[washItemUrlified][filterArrays.washes[washItemUrlified].length] = cacheKey;
			}

			// Sizes lookup
			Object.keys(item.sizes).forEach((sizeKey) => {
				const sizeItem = item.sizes[sizeKey];
				const sizeKeyUrlified = urlify(sizeItem.name);

				if (!filterArrays.sizes[categoryType][sizeKeyUrlified]) {
					filterArrays.sizes[categoryType][sizeKeyUrlified] = [];
					filterDescriptions.sizes[sizeKeyUrlified] = sizeItem.name;
				}
				if (sizeItem.stock === 0) return;
				filterArrays.sizes[categoryType][sizeKeyUrlified][filterArrays.sizes[categoryType][sizeKeyUrlified].length] = cacheKey;
			});

			// Styles lookup
			if (item.pr_style) {
				Object.keys(item.pr_style).forEach((styleKey) => {
					const styleItem = item.pr_style[styleKey];
					const styleItemUrlified = urlify(styleItem);
					if (!filterArrays.styles[styleItemUrlified]) {
						filterArrays.styles[styleItemUrlified] = [];
						filterDescriptions.styles[styleItemUrlified] = styleItem;
					}
					filterArrays.styles[styleItemUrlified][filterArrays.styles[styleItemUrlified].length] = cacheKey;
				});
			}

			// Styles lookup
			if (item.pr_rise) {
				const riseItem = item.pr_rise;
				const riseItemUrlified = urlify(riseItem);
				if (!filterArrays.rise[riseItemUrlified]) {
					filterArrays.rise[riseItemUrlified] = [];
					filterDescriptions.rise[riseItemUrlified] = riseItem;
				}
				filterArrays.rise[riseItemUrlified][filterArrays.rise[riseItemUrlified].length] = cacheKey;
			}

			// Search Terms
			searchTerms[languageKeys[0]][item.name + item.variantName] = searchTerms[languageKeys[0]][item.name + item.variantName] ? [...searchTerms[languageKeys[0]][item.name + item.variantName], cacheKey] : [cacheKey];

			// Sale / News
			if (item.price.showAsOnSale) filterArrays.productsOnSale[filterArrays.productsOnSale.length] = cacheKey;
			if (item.price.newProduct) filterArrays.newProducts[filterArrays.newProducts.length] = cacheKey;
		});

		/*
			Extend search terms.
		*/

		// Categories
		Object.keys(filterDescriptions.categories).forEach((category) => {
			const categorySearchTerm = searchTerms[languageKeys[0]][filterDescriptions.categories[category]];
			searchTerms[languageKeys[0]][filterDescriptions.categories[category]] = !categorySearchTerm ? filterArrays.categories[category] : [...categorySearchTerm, ...filterArrays.categories[category]];

			if (languages.length > 1) {
				languageKeys.slice(1).forEach((language) => {
					if (localized[language.value] && localized[language.value].categories && localized[language.value].categories[category]) {
						const localizedCategorySearchTerm = searchTerms[language.value][localized[language.value].categories[category].description];
						searchTerms[language.value][localized[language.value].categories[category].description] = !localizedCategorySearchTerm ? filterArrays.categories[category] : [...localizedCategorySearchTerm, ...filterArrays.categories[category]];
					} else {
						const localizedCategorySearchTerm = searchTerms[language.value][filterDescriptions.categories[category]];
						searchTerms[language.value][filterDescriptions.categories[category]] = !localizedCategorySearchTerm ? filterArrays.categories[category] : [...localizedCategorySearchTerm, ...filterArrays.categories[category]];
					}
				});
			}
		});

		// Colors
		Object.keys(filterDescriptions.colors).forEach((color) => {
			const colorSearchTerm = searchTerms[languageKeys[0]][filterDescriptions.colors[color].text];
			searchTerms[languageKeys[0]][filterDescriptions.colors[color].text] = !colorSearchTerm ? filterArrays.colors[color] : [...colorSearchTerm, ...filterArrays.colors[color]];

			if (languages.length > 1) {
				languageKeys.slice(1).forEach((language) => {
					if (localized?.[language.value]?.colors?.[color]) {
						const localizedColorSearchTerm = searchTerms[language.value][localized[language.value].colors[color].text];
						searchTerms[language.value][localized[language.value].colors[color].text] = !localizedColorSearchTerm ? filterArrays.colors[color] : [...localizedColorSearchTerm, ...filterArrays.colors[color]];
					} else {
						const localizedColorSearchTerm = searchTerms[language.value][filterDescriptions.colors[color].text];
						searchTerms[language.value][filterDescriptions.colors[color].text] = !localizedColorSearchTerm ? filterArrays.colors[color] : [...localizedColorSearchTerm, ...filterArrays.colors[color]];
					}
				});
			}
		});

		// styles
		Object.keys(filterDescriptions.styles).forEach((style) => {
			const styleSearchTerm = searchTerms[languageKeys[0]][filterDescriptions.styles[style]];
			searchTerms[languageKeys[0]][filterDescriptions.styles[style]] = !styleSearchTerm ? filterArrays.styles[style] : [...styleSearchTerm, ...filterArrays.styles[style]];

			if (languages.length > 1) {
				languageKeys.slice(1).forEach((language) => {
					if (localized?.[language.value]?.styles?.[style]) {
						const localizedstyleSearchTerm = searchTerms[language.value][localized[language.value].styles[style]];
						searchTerms[language.value][localized[language.value].styles[style]] = !localizedstyleSearchTerm ? filterArrays.styles[style] : [...localizedstyleSearchTerm, ...filterArrays.styles[style]];
					} else {
						const localizedstyleSearchTerm = searchTerms[language.value][filterDescriptions.styles[style]];
						searchTerms[language.value][filterDescriptions.styles[style]] = !localizedstyleSearchTerm ? filterArrays.styles[style] : [...localizedstyleSearchTerm, ...filterArrays.styles[style]];
					}
				});
			}
		});

		// washes
		Object.keys(filterDescriptions.washes).forEach((wash) => {
			const washSearchTerm = searchTerms[languageKeys[0]][filterDescriptions.washes[wash]];
			searchTerms[languageKeys[0]][filterDescriptions.washes[wash].text] = !washSearchTerm ? filterArrays.washes[wash] : [...washSearchTerm, ...filterArrays.washes[wash]];

			if (languages.length > 1) {
				languageKeys.slice(1).forEach((language) => {
					if (localized?.[language.value]?.washes?.[wash]) {
						const localizedwashSearchTerm = searchTerms[language.value][localized[language.value].washes[wash]];
						searchTerms[language.value][localized[language.value].washes[wash].text] = !localizedwashSearchTerm ? filterArrays.washes[wash] : [...localizedwashSearchTerm, ...filterArrays.washes[wash]];
					} else {
						const localizedwashSearchTerm = searchTerms[language.value][filterDescriptions.washes[wash]];
						searchTerms[language.value][filterDescriptions.washes[wash].text] = !localizedwashSearchTerm ? filterArrays.washes[wash] : [...localizedwashSearchTerm, ...filterArrays.washes[wash]];
					}
				});
			}
		});


		return {
			...state,
			[action.market]: {
				...state[action.market],
				[action.pricelist]: {
					products: cache,
					filterArrays,
					filterDescriptions,
					localized,
					searchTerms,
				},
			},
		};
	}

	return state;
};
